import React, { useState, useEffect } from 'react'
import styled from 'styled-components';
import axios from 'axios';
import { List, Spin } from 'antd';

import _ from 'lodash';

const TaskDetails = ({task}) => {

  const [details, setDetails] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if(!_.isEmpty(task)) {
      axios.post('/api/wt/workflow/dto/details/read', { ...task }).then(
        res => { 
          setDetails(res.data.data);
          setLoading(false);
        }
      ).catch(error => {
        alert(`Error loading details.`)
        console.error(error);
        setLoading(false);
      });
    }
  }, [task])

  const listData = [
    {
      title: 'Route Instance',
      field: 'routeInstance'
    },
    {
      title: 'Route Name',
      field: 'routeName'
    },
    {
      title: 'Step Name',
      field: 'stepName'
    },
    {
      title: 'Requested By',
      field: 'requestedBy'
    },
    {
      title: 'Requested On',
      field: 'requestedOn'
    },
    {
      title: 'Assigned To',
      field: 'assignedTo'
    },
    {
      title: 'Step Start Date',
      field: 'stepStartDate'
    },
    {
      title: 'Step Time Out',
      field: 'stepTimeOut'
    },
    {
      title: 'Instance ID',
      field: 'instanceId'
    },
  ]

  return (
    <>
      {!loading && 
        <List
          bordered={false}
          split={false}
          itemLayout="horizontal"
          dataSource={listData}
          renderItem={item => (
            <List.Item style={{paddingLeft: '10px'}}>
              <List.Item.Meta
                title={item.title}
                description={
                  item.field === 'assignedTo' ?
                  details[item.field].join(', ') :
                  details[item.field]
                }
              />
            </List.Item>
          )}
        />
      }
      {loading && 
        <Spinner>
          <Spin />
        </Spinner>
      }
    </>
  )
}

const Spinner = styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export default TaskDetails;
